import {useQuery} from '@tanstack/react-query';
import {rqCreateSearchRequest} from '@app/reactQuery/apis/rqHttpsUtils';
import {RQ_GET_MARKETING_ACTIVITY_REPORTS_API} from '@app/reactQuery/apis/constants';

export const RQUseGetMarketingActivityReportData = (payload, options = {}) => {
  return useQuery({
    queryKey:['rq_get_marketing_activity_report_data', payload],
    queryFn: async ({queryKey, signal}) => {
      const {certificate, divisionId, startDate, endDate} = queryKey[1];
      return rqCreateSearchRequest(
        RQ_GET_MARKETING_ACTIVITY_REPORTS_API,
        null,
        certificate,
        {
          divisionId: divisionId,
          fromYearMonthDate: startDate,
          toYearMonthDate: endDate,
        },
        signal,
      );
    },
    ...options,
  });
};
